import { useState } from 'react';
import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            观众热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            真实追剧用户的评价和推荐，看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentItems.map((comment) => (
            <CommentCard key={comment.id} comment={comment} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CommentCard({ comment }: { comment: typeof commentItems[0] }) {
  const [avatarError, setAvatarError] = useState(false);

  return (
    <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
          {!avatarError ? (
            <img
              src={comment.avatar}
              alt={comment.name}
              className="w-full h-full object-cover"
              onError={() => setAvatarError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-primary-100 text-primary-500">
              <span className="text-sm font-bold">{comment.name.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">
              {comment.name}
            </span>
            <span className="text-xs text-foreground-400">{comment.date}</span>
          </div>
          <div className="flex items-center gap-0.5 mt-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <div key={star} className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-xs text-accent-400"></i>
              </div>
            ))}
          </div>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            {comment.text}
          </p>
          <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-thumb-up-line"></i>
            </div>
            <span>{comment.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
}